import React from 'react';
import { object, string } from 'prop-types';
import { Box, Center, Text, Image, AspectRatio } from '@chakra-ui/react';

import InstagramButton from '@/components/Common/InstagramButton';
import WithAnimation from '@/components/Common/WithAnimation';

import { BUTTON_PADDING_PROPS, BG_LAYER } from '@/constants/colors';
import { ASSETS_KAWUNG_SIMBOL, ASSETS_FLOWER_2 } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

function DetailCouple(props) {
  const {
    imgUrl,
    instagramId,
    parentName,
    fullName,
    shortName,
    instagramIdProps,
    fullNameProps,
    parentNameProps,
    i,
    ...rest
  } = props;

  return (
    <Box
      padding="48px 0 24px 0"
      width="100%"
      minHeight={{ '3sm': '100vh', '2sm': '90vh', '1sm': '100vh', sm: '90vh' }}
      pos="relative"
      mt={i === 0 ? '150px' : ''}
      zIndex="2"
      {...rest}
    >
      <Box
        className="animation__flower"
        position="absolute"
        top={i == 1 ? '150px' : '60px'}
        left="-90px"
        zIndex="10"
      >
        <WithAnimation left delay={1000}>
          <Image
            src={ASSETS_FLOWER_2}
            width={{ '3sm': '240px', '2sm': '260px', sm: '180px' }}
            transform="rotate(16deg)"
          />
        </WithAnimation>
      </Box>

      <Box
        className="animation__flower"
        position="absolute"
        top={i == 1 ? '250px' : '200px'}
        right="-100px"
        zIndex="10"
      >
        <WithAnimation right delay={1100}>
          <Image
            src={ASSETS_FLOWER_2}
            width={{ '3sm': '240px', '2sm': '240px', sm: '180px' }}
            transform="rotateY(180deg)"
          />
        </WithAnimation>
      </Box>

      <Box
        paddingTop={i == 1 ? '50px' : ''}
        pos="relative"
        mx="auto"
        width={{ lg: '70%', base: '80%' }}
        zIndex="3"
      >
        <WithAnimation>
          <Box
            borderRadius="16px"
            border="1px solid"
            borderColor="bgSecondary"
            bgColor={BG_LAYER}
            minHeight="50vh"
            padding="24px"
            my="24px"
            {...TEXT_PROPS.body}
            textAlign="center"
          >
            {/* photo frame */}
            {imgUrl && (
              <Box height="40%" marginTop="-150px" pb="24px">
                <WithAnimation type="zoom" delay={500}>
                  <AspectRatio ratio={3 / 4} maxWidth="400px">
                    <Image
                      src={imgUrl}
                      maxWidth="100%"
                      borderRadius="16px"
                      border="3px solid"
                      borderColor="bgSecondary"
                    />
                  </AspectRatio>
                </WithAnimation>
              </Box>
            )}
            {/* info */}
            <Box height="60%" pos="relative" zIndex="5" textAlign="center">
              <WithAnimation delay={500} type="zoom">
                <Text {...TEXT_PROPS.heading} fontWeight="bold">{shortName}</Text>
              </WithAnimation>
              <WithAnimation delay={600}>
                <Text {...TEXT_PROPS.body} fontSize="20px" {...fullNameProps}>
                  {fullName}
                </Text>
              </WithAnimation>
              <WithAnimation delay={650} type="zoom">
                <Image src={ASSETS_KAWUNG_SIMBOL} maxW="25px" mx="auto" />
              </WithAnimation>
              <WithAnimation delay={700}>
                <Text
                  {...TEXT_PROPS.body}
                  dangerouslySetInnerHTML={{ __html: parentName }}
                  {...parentNameProps}
                />
              </WithAnimation>
              {instagramId && (
                <Center marginTop="24px">
                  <WithAnimation delay={700}>
                    <InstagramButton
                      id={instagramId}
                      text={instagramId}
                      color="white"
                      onlyIcon={false}
                      size="md"
                      {...BUTTON_PADDING_PROPS}
                      {...instagramIdProps}
                      fontSize="md"
                    />
                  </WithAnimation>
                </Center>
              )}
            </Box>
          </Box>
        </WithAnimation>
      </Box>
    </Box>
  );
}

DetailCouple.propTypes = {
  imgUrl: string.isRequired,
  instagramId: string,
  parentName: string,
  fullName: string,
  shortName: string,
  i: object,
  instagramIdProps: object,
  fullNameProps: object,
  parentNameProps: object,
};

DetailCouple.defaultProps = {
  instagramId: '',
  fullName: '',
  instagramIdProps: {},
  fullNameProps: {},
  shortName: '',
  parentName: '',
  parentNameProps: {},
  i: { index: 0 },
};

export default DetailCouple;
